
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { ExcelService } from 'src/app/shared/services/excel.service';
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Parametro } from 'src/app/shared/models/parametro';
import { ParametrosDialogComponent } from './parametros-dialog.component';
import { ParametrosService } from '../../../shared/services/parametros.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';


@Component({
  selector: 'app-parametros',
  templateUrl: './parametros.component.html'
})
export class ParametrosComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private parametroService: ParametrosService,
    public exporExcelService: ExcelService) { }

  displayedColumns = ['acciones', 'id', 'descripcion', 'habilitacion'];
  dataSource = new MatTableDataSource<Parametro>();

  public Etiquetas: {
    Titulo: string
    SinRegistros: string
    Buscar: string
    BotonAParametro: string
    Headers: {
      Acciones: string,
      Descripcion: string,
      Habilitacion: string,
      Id: string
    }
  }
  public Tooltips: {
    Eliminar: string
    Editar: string
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }
  ngOnInit(): void {

    if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADMVENTAS') && !this.loggedService.isInRole('ADM LOCAL') && !this.loggedService.isInRole('CONSULTOR')) {
      this.router.navigateByUrl('');
    }
    this.Etiquetas = {
      BotonAParametro: this.configService.etiquetas.Parametros.BotonAParametro,
      Buscar: this.configService.etiquetas.Buscar,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Titulo: this.configService.etiquetas.Parametros.Titulo,
      Headers: {
        Acciones: this.configService.etiquetas.Acciones,
        Descripcion: this.configService.etiquetas.Descripcion,
        Habilitacion: this.configService.etiquetas.Habilitacion,
        Id: this.configService.etiquetas.Id
      }
    }

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
    }
    this.buscar(0);
  }
  buscar(idTipoMensaje: number) {


    this.parametroService
      .cParametros()
      .subscribe((parametros: Parametro[]) => {
        if (parametros.length) {

          this.dataSource.data = [];
          this.dataSource.data = parametros;
          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExcelExitosa, 1, 1)
              break;
          }
        }

      })


  }

  dialogParametro(idTipo: number, p: Parametro) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { parametro: p, idTipo: idTipo }
    let dialogRef = this.dialog.open(ParametrosDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: Parametro) => {
      if (data != null) {
        this.buscar(idTipo);
      }

    })

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
